import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  const teamMembers = [
    {
      name: "Col Raja Somusundaram (Retd)",
      role: "Founder & CMD",
      image: "/images/raja.png",
      bio: "A passionate golf enthusiast and accomplished player who, after years on the green, founded Golf4i International to address the unique challenges faced by golfers and drive innovation in the golfing industry.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    },
    {
      name: "Lt Col (Mrs) Arita Raja (Retd)",
      role: "Director",
      image: "/images/arita.png",
      bio: "Driving innovation in the global golf industry and delivering expert strategy in golfing business development, bringing strategic vision and operational excellence to Golf 4i International's mission of revolutionizing the golfing experience.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    },
    {
      name: "Golf Simulator Operator – Kolkata",
      role: "Golf Simulator Operator – Kolkata",
      image: "/images/operator.png",
      bio: "An expert in golf simulator technology and software integration, leading advancements at Golf 4i International to create immersive, data-driven golfing solutions for players and businesses worldwide.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    },
    {
      name: "Mr. Mahesh Ahirwar",
      role: "Accountant",
      image: "/images/mahesh.png",
      bio: "Manages financial records and ensures all transactions are accurately recorded. Prepares reports and statements to support business planning and decisions. Ensures compliance with financial regulations and helps maintain financial health.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    }
  ];

  const milestones = [
    { year: "2022", event: "Company Founded", detail: "Golf4International Private Limited established" },
    { year: "2023", event: "First Facility Launch", detail: "Delhi headquarters and training center opened" },
    { year: "2024", event: "Technology Integration", detail: "Advanced simulator systems implemented" },
    { year: "2025", event: "National Expansion", detail: "Planned expansion to 5 major cities" }
  ];

  const stats = [
    { value: "1000+", label: "Students Trained", icon: "👨‍🎓" },
    { value: "15+", label: "Certified Coaches", icon: "🏌️" },
    { value: "24/7", label: "Simulator Access", icon: "🖥️" },
    { value: "4", label: "Team Members", icon: "👥" },
    { value: "98%", label: "Satisfaction Rate", icon: "⭐" },
    { value: "5", label: "Cities Planned", icon: "🏙️" }
  ];

  const missionValues = [
    { icon: "🌱", title: "Accessibility", description: "Making golf available to everyone regardless of background or skill level" },
    { icon: "🎯", title: "Excellence", description: "Maintaining the highest standards in coaching and facilities" },
    { icon: "💡", title: "Innovation", description: "Leveraging technology to enhance the golfing experience" },
    { icon: "🤝", title: "Community", description: "Building a supportive network of golf enthusiasts" }
  ];

  const visionGoals = [
    { icon: "🏆", title: "Global Recognition", description: "Position India as a global golfing destination" },
    { icon: "🎓", title: "Talent Development", description: "Nurture world-class golf professionals from India" },
    { icon: "🏗️", title: "Infrastructure Growth", description: "Establish 20+ international-standard facilities" },
    { icon: "🌍", title: "International Impact", description: "Host PGA-level tournaments in India" }
  ];

  return (
    <>
      {/* Hero Section - Standardized with Blog Page */}
      <section className="about-hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-pattern"></div>

        <Container className="position-relative z-3 h-100">
          <Row className="h-100 align-items-center justify-content-center">
            <Col xs={12} lg={10} xl={8} className="text-center text-white">
              <h1 className="hero-title mb-4">About Golf4International</h1>
              <p className="hero-subtitle mb-5">
                Transforming India's golf landscape through innovation, accessibility, and excellence since 2022
              </p>
              <div className="hero-cta d-flex flex-column flex-sm-row justify-content-center gap-3">
                <a href="#mission-vision" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                  Our Mission & Vision
                </a>
                <a href="#team" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                  Meet Our Team
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Story Section */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center g-4 g-lg-5 mb-5">
            <Col xs={12} className="text-center mb-5">
              <h2 className="section-title mb-3">Our Story</h2>
              <p className="section-subtitle">
                Pioneering golf accessibility in India through innovation and dedication
              </p>
            </Col>

            <Col lg={6} className="order-2 order-lg-1">
              <div className="content-wrapper">
                <p className="mb-4">
                  Founded in 2022, Golf4International emerged from a vision to democratize golf in India.
                  We recognized that traditional golf models created unnecessary barriers, making this
                  beautiful sport seem exclusive and inaccessible to the masses.
                </p>
                <p className="mb-0">
                  Our journey began with a simple yet powerful idea: to make golf accessible, affordable,
                  and enjoyable for everyone. By leveraging cutting-edge technology and innovative training
                  methodologies, we're redefining what's possible in Indian golf.
                </p>
              </div>
            </Col>

            <Col lg={6} className="order-1 order-lg-2">
              <div className="story-img rounded">
                <div className="story-badge">
                  <span className="small fw-bold">🏆 Since 2022</span>
                </div>
              </div>
            </Col>
          </Row>

          {/* Stats Section */}
          <Row className="mt-5">
            {stats.map((stat, index) => (
              <Col xs={6} sm={4} lg={2} className="text-center mb-4" key={index}>
                <div className="stat-card p-3">
                  <div className="stat-icon mb-3">
                    {stat.icon}
                  </div>
                  <h3 className="stat-number mb-1">{stat.value}</h3>
                  <p className="stat-label small fw-medium mb-0">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Enhanced Mission & Vision Section */}
      <section id="mission-vision" className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Our Mission & Vision</h2>
              <p className="section-subtitle mb-0">
                Driving the future of golf in India through purposeful innovation
              </p>
            </Col>
          </Row>

          {/* Mission Section */}
          <Row className="mb-5 pb-lg-5">
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="mission-card card-modern h-100 position-relative">
                <div className="mission-decorative"></div>
                <div className="d-flex align-items-start mb-4">
                  <div className="mission-icon me-3">
                    <span className="h4 text-white mb-0">🎯</span>
                  </div>
                  <div>
                    <h3 className="h4 mb-2 text-gold">Our Mission</h3>
                    <p className="mission-tagline text-muted mb-0">Making Golf Accessible for All</p>
                  </div>
                </div>

                <div className="mission-content">
                  <p className="mb-4">
                    To revolutionize golf accessibility in India by creating inclusive, technology-driven
                    solutions that make golf affordable, enjoyable, and within reach of every enthusiast,
                    while maintaining international standards of excellence.
                  </p>

                  <div className="mission-values mt-4 pt-4 border-top">
                    <h4 className="h5 mb-4 text-green">Core Values:</h4>
                    <Row className="g-3">
                      {missionValues.map((value, index) => (
                        <Col xs={6} key={index}>
                          <div className="value-item p-3 bg-white rounded">
                            <div className="value-icon mb-2">
                              {value.icon}
                            </div>
                            <h5 className="h6 mb-1 value-title">{value.title}</h5>
                            <p className="value-desc small mb-0">{value.description}</p>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="vision-card card-modern h-100 position-relative">
                <div className="vision-decorative"></div>
                <div className="d-flex align-items-start mb-4">
                  <div className="vision-icon me-3">
                    <span className="h4 text-white mb-0">🌟</span>
                  </div>
                  <div>
                    <h3 className="h4 mb-2 text-green">Our Vision</h3>
                    <p className="vision-tagline text-muted mb-0">Creating Golf Champions & Champions</p>
                  </div>
                </div>

                <div className="vision-content">
                  <p className="mb-4">
                    To establish India as a global golfing powerhouse by nurturing world-class talent,
                    developing international-standard infrastructure, and creating a sustainable golf
                    ecosystem that produces champions on and off the course.
                  </p>

                  <div className="vision-goals mt-4 pt-4 border-top">
                    <h4 className="h5 mb-4 text-gold">Strategic Goals (2030):</h4>
                    <div className="goals-timeline">
                      {visionGoals.map((goal, index) => (
                        <div key={index} className="goal-item mb-3">
                          <div className="d-flex align-items-start">
                            <div className="goal-icon me-3">
                              {goal.icon}
                            </div>
                            <div>
                              <h5 className="h6 mb-1 goal-title">{goal.title}</h5>
                              <p className="goal-desc small mb-0">{goal.description}</p>
                            </div>
                          </div>
                          {index < visionGoals.length - 1 && <div className="goal-connector"></div>}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Mission & Vision Comparison */}
          <Row className="mt-5">
            <Col xs={12}>
              <div className="comparison-card card-modern p-4 p-md-5">
                <h3 className="h4 text-center mb-4">Mission vs Vision: Our Strategic Path</h3>
                <Row className="align-items-center">
                  <Col md={5} className="text-center mb-4 mb-md-0">
                    <div className="comparison-icon mission-compare-icon">
                      🎯
                    </div>
                    <h4 className="h5 mt-3 mb-2">What We Do Today</h4>
                    <p className="small mb-0">Action-oriented, measurable objectives</p>
                  </Col>

                  <Col md={2} className="text-center my-4 my-md-0">
                    <div className="comparison-arrow">
                      <i className="fas fa-arrow-right fa-2x text-gold"></i>
                    </div>
                  </Col>

                  <Col md={5} className="text-center">
                    <div className="comparison-icon vision-compare-icon">
                      🌟
                    </div>
                    <h4 className="h5 mt-3 mb-2">Where We're Headed</h4>
                    <p className="small mb-0">Inspirational long-term aspirations</p>
                  </Col>
                </Row>

                <div className="comparison-divider"></div>

                <Row className="mt-4">
                  <Col md={6}>
                    <ul className="comparison-list mission-list">
                      <li className="mb-2">Democratizing golf access nationwide</li>
                      <li className="mb-2">Implementing affordable training programs</li>
                      <li className="mb-2">Integrating cutting-edge simulator technology</li>
                      <li className="mb-0">Building local golf communities</li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <ul className="comparison-list vision-list">
                      <li className="mb-2">Producing international golf champions</li>
                      <li className="mb-2">Establishing India as golf tourism hub</li>
                      <li className="mb-2">Creating sustainable golf infrastructure</li>
                      <li className="mb-0">Influencing global golf standards</li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team Section */}
      <section id="team" className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">🤝 Meet Our Team</h2>
              <p className="section-subtitle">
                Dedicated professionals driving golfing excellence
              </p>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
            {teamMembers.map((member, index) => (
              <Col xs={12} sm={6} lg={3} key={index}>
                <div className="team-card card-modern h-100 d-flex flex-column">
                  <div
                    className="team-member-img"
                    style={{ backgroundImage: `url(${member.image})` }}
                  >
                    <div className="team-img-overlay"></div>
                    <div className="team-role-badge">
                      <span className="small fw-bold">{member.role}</span>
                    </div>
                  </div>

                  <div className="team-content d-flex flex-column flex-grow-1 p-3 p-md-4">
                    <h4 className="h5 mb-2 team-member-name">{member.name}</h4>

                    <p className="team-member-bio flex-grow-1 mb-3">
                      {member.bio}
                    </p>

                    {/* Social Links */}
                    <div className="team-social pt-3 border-top">
                      <a
                        href={member.social.linkedin}
                        className="text-decoration-none me-3"
                        title="LinkedIn"
                      >
                        <i className="fab fa-linkedin fa-lg"></i>
                      </a>
                      <a
                        href={member.social.twitter}
                        className="text-decoration-none"
                        title="Twitter"
                      >
                        <i className="fab fa-twitter fa-lg"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Team Description */}
          <Row className="mt-5">
            <Col xs={12} className="text-center">
              <div className="team-description p-4 p-md-5 rounded">
                <h3 className="h4 mb-3">🌐 The People Behind the Precision</h3>
                <p className="mb-0">
                  Golf4i is backed by a dynamic team of golf pros, engineers, product designers, support technicians,
                  and strategic advisors. We blend sports knowledge with tech innovation to build the future of golf in India.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Journey Timeline */}
      <section id="journey" className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Our Journey</h2>
              <p className="section-subtitle">
                Key milestones in our mission to transform golf accessibility in India
              </p>
            </Col>
          </Row>

          <div className="timeline-container">
            {milestones.map((milestone, index) => (
              <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-content">
                  <h3 className="h4 mb-2 timeline-year">{milestone.year}</h3>
                  <h4 className="h5 mb-2">{milestone.event}</h4>
                  <p className="mb-0">{milestone.detail}</p>
                </div>
                <div className="timeline-dot"></div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section-padding">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} lg={8} className="text-center">
              <div className="newsletter-card">
                <div className="newsletter-icon mb-4">
                  ⛳
                </div>
                <h3 className="h2 mb-3 text-white">Join Our Golf Revolution</h3>
                <p className="newsletter-text mb-4">
                  Be part of India's growing golf community. Whether you're a beginner or a seasoned player,
                  we have the perfect program for you.
                </p>
                <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                  <a href="/contact" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                    Get in Touch
                  </a>
                  <a href="/services" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                    Explore Services
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CSS Styles */}
      <style jsx>{`
        /* Hero Section - Standardized with Blog Page */
        .about-hero-section {
          height: 70vh;
          min-height: 600px;
          background: linear-gradient(rgba(31, 61, 43, 0.6), rgba(31, 61, 43, 0.75)), 
                     url('https://images.unsplash.com/photo-1535131749006-b7f58c99034b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80') center/cover no-repeat;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding-top: 80px;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(31, 61, 43, 0.5) 0%, rgba(31, 61, 43, 0.7) 100%);
          z-index: 1;
        }
        
        .hero-pattern {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(circle at center, rgba(181, 154, 90, 0.1) 0%, transparent 70%);
          animation: pulse 4s ease-in-out infinite;
          z-index: 1;
        }
        
        .hero-title {
          font-size: clamp(2rem, 5vw, 3.5rem);
          color: #B59A5A;
          font-weight: 600;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          line-height: 1.2;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }
        
        .hero-subtitle {
          font-size: clamp(1rem, 2.5vw, 1.5rem);
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.95);
          text-shadow: 0 1px 3px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          margin-bottom: 2.5rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        .hero-cta {
          position: relative;
          z-index: 2;
        }
        
        /* Button Styles */
        .btn-gold-filled {
          background-color: #B59A5A;
          color: #1F3D2B;
          border: none;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold-filled:hover {
          background-color: #d4b56e;
          color: #1F3D2B;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        .btn-gold {
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(5px);
          color: #B59A5A;
          border: 2px solid #B59A5A;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold:hover {
          background-color: rgba(181, 154, 90, 0.2);
          color: #d4b56e;
          border-color: #d4b56e;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        /* Section Styles */
        .section-padding {
          padding: clamp(3rem, 6vw, 5rem) 0;
        }
        
        .section-padding-sm {
          padding: clamp(1.5rem, 3vw, 3rem) 0;
        }
        
        .section-title {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          color: #1F3D2B;
          font-weight: 600;
          margin-bottom: 1rem;
          line-height: 1.2;
          font-family: 'Playfair Display', serif;
        }
        
        .section-subtitle {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        /* Story Section */
        .story-img {
          height: 300px;
          background: url('https://plus.unsplash.com/premium_photo-1725408156943-6fb39d08458d?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Z29sZiUyMGdyZWVufGVufDB8fDB8fHww') center/cover no-repeat;
          width: 100%;
          position: relative;
          border-radius: 12px;
          overflow: hidden;
        }
        
        .story-badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 50px;
          padding: 0.5rem 1rem;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        .story-icon {
          font-size: clamp(3rem, 6vw, 4rem);
          color: #B59A5A;
          margin-bottom: 1.5rem;
        }
        
        /* Content Wrapper */
        .content-wrapper p {
          font-size: clamp(1rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          color: #666;
          margin-bottom: 1.5rem;
        }
        
        /* Stats Section */
        .stat-card {
          transition: transform 0.3s ease;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          height: 100%;
        }
        
        .stat-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }
        
        .stat-icon {
          width: clamp(50px, 8vw, 60px);
          height: clamp(50px, 8vw, 60px);
          background-color: #f0f7f3;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
          margin: 0 auto 1rem;
        }
        
        .stat-number {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          color: #B59A5A;
          font-weight: 600;
          margin-bottom: 0.5rem;
          font-family: 'Playfair Display', serif;
        }
        
        .stat-label {
          color: #666;
          font-size: clamp(0.8rem, 1.5vw, 0.9rem);
          margin-bottom: 0;
          font-weight: 400;
        }
        
        /* Enhanced Mission & Vision Cards */
        .mission-card, .vision-card {
          padding: clamp(1.5rem, 3vw, 2rem);
          height: 100%;
          position: relative;
          overflow: hidden;
          border: none;
        }
        
        .mission-decorative, .vision-decorative {
          position: absolute;
          top: 0;
          right: 0;
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, transparent 50%, rgba(181, 154, 90, 0.05) 50%);
          border-radius: 0 0 0 100%;
        }
        
        .vision-decorative {
          background: linear-gradient(135deg, transparent 50%, rgba(31, 61, 43, 0.05) 50%);
        }
        
        .mission-icon, .vision-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: linear-gradient(135deg, #B59A5A 0%, #d4b56e 100%);
          box-shadow: 0 4px 12px rgba(181, 154, 90, 0.2);
        }
        
        .vision-icon {
          background: linear-gradient(135deg, #1F3D2B 0%, #2a4d3b 100%);
          box-shadow: 0 4px 12px rgba(31, 61, 43, 0.2);
        }
        
        .mission-tagline, .vision-tagline {
          font-size: 0.9rem;
          font-weight: 500;
        }
        
        /* Mission Values */
        .mission-values {
          margin-top: 2rem;
          padding-top: 2rem;
        }
        
        .value-item {
          transition: all 0.3s ease;
          height: 100%;
          border: 1px solid rgba(181, 154, 90, 0.1);
        }
        
        .value-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 16px rgba(181, 154, 90, 0.1);
          border-color: rgba(181, 154, 90, 0.2);
        }
        
        .value-icon {
          font-size: 1.5rem;
          color: #B59A5A;
        }
        
        .value-title {
          color: #1F3D2B;
          font-weight: 600;
          font-size: 0.95rem;
        }
        
        .value-desc {
          color: #666;
          line-height: 1.4;
        }
        
        /* Vision Goals */
        .vision-goals {
          margin-top: 2rem;
          padding-top: 2rem;
        }
        
        .goals-timeline {
          position: relative;
        }
        
        .goal-item {
          position: relative;
        }
        
        .goal-icon {
          width: 40px;
          height: 40px;
          background: #f0f7f3;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 1.2rem;
          color: #1F3D2B;
        }
        
        .goal-title {
          color: #1F3D2B;
          font-weight: 600;
          font-size: 0.95rem;
        }
        
        .goal-desc {
          color: #666;
          line-height: 1.4;
        }
        
        .goal-connector {
          height: 20px;
          width: 2px;
          background: #e3ece6;
          margin-left: 20px;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        
        /* Comparison Section */
        .comparison-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
          border: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .comparison-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          margin: 0 auto;
        }
        
        .mission-compare-icon {
          background: linear-gradient(135deg, rgba(181, 154, 90, 0.1) 0%, rgba(181, 154, 90, 0.2) 100%);
          color: #B59A5A;
        }
        
        .vision-compare-icon {
          background: linear-gradient(135deg, rgba(31, 61, 43, 0.1) 0%, rgba(31, 61, 43, 0.2) 100%);
          color: #1F3D2B;
        }
        
        .comparison-arrow {
          color: #B59A5A;
        }
        
        .comparison-divider {
          height: 2px;
          background: linear-gradient(90deg, transparent, #e3ece6, transparent);
          margin: 2rem 0;
        }
        
        .comparison-list {
          padding-left: 1.2rem;
          margin-bottom: 0;
        }
        
        .comparison-list li {
          margin-bottom: 0.75rem;
          color: #666;
          position: relative;
          padding-left: 0.5rem;
        }
        
        .mission-list li::marker {
          color: #B59A5A;
        }
        
        .vision-list li::marker {
          color: #1F3D2B;
        }
        
        /* Text Colors */
        .text-gold {
          color: #B59A5A;
        }
        
        .text-green {
          color: #1F3D2B;
        }
        
        .text-muted {
          color: #666;
        }
        
        /* Team Section */
        .team-card {
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        
        .team-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }
        
        .team-member-img {
          height: 250px;
          width: 100%;
          background-size: cover;
          background-position: center;
          position: relative;
        }
        
        .team-img-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to bottom, transparent 60%, rgba(31, 61, 43, 0.7) 100%);
        }
        
        .team-role-badge {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 50px;
          padding: 0.25rem 0.75rem;
          font-size: 0.8rem;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        .team-member-name {
          color: #1F3D2B;
          font-weight: 600;
          transition: color 0.3s ease;
          font-family: 'Playfair Display', serif;
          font-size: clamp(1rem, 1.8vw, 1.25rem);
        }
        
        .team-card:hover .team-member-name {
          color: #B59A5A;
        }
        
        .team-member-bio {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.5;
          flex-grow: 1;
        }
        
        .team-social {
          border-top: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .team-social a {
          color: #0077B5;
          transition: color 0.3s ease;
        }
        
        .team-social a:hover {
          color: #B59A5A;
        }
        
        .team-description {
          background: #f0f7f3;
          border-left: 4px solid #B59A5A;
          border-radius: 8px;
        }
        
        /* Timeline Section */
        .timeline-container {
          position: relative;
          max-width: 800px;
          margin: 0 auto;
        }
        
        .timeline-container::before {
          content: '';
          position: absolute;
          left: 50%;
          top: 0;
          bottom: 0;
          width: 3px;
          background-color: #B59A5A;
          transform: translateX(-50%);
        }
        
        .timeline-item {
          display: flex;
          align-items: center;
          margin-bottom: clamp(2rem, 4vw, 3rem);
          position: relative;
        }
        
        .timeline-item.left {
          flex-direction: row-reverse;
        }
        
        .timeline-item.right {
          flex-direction: row;
        }
        
        .timeline-content {
          width: 45%;
          padding: clamp(1rem, 2vw, 1.5rem);
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          border-left: 3px solid #B59A5A;
        }
        
        .timeline-dot {
          width: 25px;
          height: 25px;
          background-color: #B59A5A;
          border-radius: 50%;
          border: 5px solid white;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          box-shadow: 0 0 0 3px rgba(181, 154, 90, 0.2);
          z-index: 1;
        }
        
        .timeline-year {
          color: #B59A5A;
          font-weight: 700;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
        }
        
        /* Newsletter Card */
        .newsletter-card {
          background: linear-gradient(135deg, #1F3D2B 0%, #2a4d3b 100%);
          color: white;
          padding: clamp(2rem, 4vw, 3rem);
          border-radius: 15px;
          width: 100%;
        }
        
        .newsletter-icon {
          width: clamp(60px, 10vw, 80px);
          height: clamp(60px, 10vw, 80px);
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.5rem, 3vw, 2rem);
          margin: 0 auto 1.5rem;
        }
        
        .newsletter-text {
          opacity: 0.9;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          margin-bottom: 2rem;
          font-weight: 400;
        }
        
        /* Background Colors */
        .bg-soft-sage {
          background-color: #f0f7f3;
        }
        
        /* Animations */
        @keyframes pulse {
          0%, 100% {
            opacity: 0.1;
          }
          50% {
            opacity: 0.2;
          }
        }
        
        /* Responsive Button Sizes */
        .btn-lg {
          padding: clamp(10px, 2vw, 12px) clamp(20px, 3vw, 32px);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        /* Responsive Grid Gaps */
        .g-4 {
          --bs-gutter-x: clamp(1rem, 2vw, 1.5rem);
          --bs-gutter-y: clamp(1rem, 2vw, 1.5rem);
        }
        
        /* ================= MOBILE RESPONSIVE FIXES ================= */
        
        /* Extra Small Devices - Mobile Phones */
        @media (max-width: 576px) {
          .about-hero-section {
            height: 65vh;
            min-height: 500px;
            padding-top: 100px;
          }
          
          .hero-title {
            margin-bottom: 1rem;
            font-size: 2.2rem;
          }
          
          .hero-subtitle {
            margin-bottom: 2rem;
            font-size: 1.1rem;
          }
          
          .hero-cta {
            flex-direction: column;
            gap: 1rem;
            margin-top: 20px;
          }
          
          .hero-cta .btn {
            width: 100%;
            padding: 14px 20px;
            font-size: 1rem;
          }
          
          .story-img {
            height: 250px;
            margin-bottom: 1.5rem;
          }
          
          .team-member-img {
            height: 220px;
          }
          
          .stat-card {
            padding: 1.5rem 0.5rem;
          }
          
          .mission-icon, .vision-icon {
            width: 50px;
            height: 50px;
          }
          
          .value-item {
            padding: 1rem;
          }
          
          .goal-icon {
            width: 35px;
            height: 35px;
            font-size: 1rem;
          }
          
          .comparison-icon {
            width: 60px;
            height: 60px;
            font-size: 1.5rem;
          }
          
          .timeline-container::before {
            left: 30px;
          }
          
          .timeline-item {
            flex-direction: row !important;
            margin-left: 60px;
          }
          
          .timeline-content {
            width: 100%;
          }
          
          .timeline-dot {
            left: 30px;
            transform: translateX(-50%);
          }
          
          .btn-lg {
            padding: 14px 20px;
          }
        }
        
        /* Small Devices - Larger Mobile Phones */
        @media (min-width: 577px) and (max-width: 768px) {
          .about-hero-section {
            height: 70vh;
            min-height: 550px;
            padding-top: 90px;
          }
          
          .hero-title {
            font-size: 2.8rem;
          }
          
          .hero-subtitle {
            font-size: 1.3rem;
          }
          
          .hero-cta {
            margin-top: 10px;
          }
          
          .story-img {
            height: 300px;
          }
          
          .team-member-img {
            height: 250px;
          }
        }
        
        /* Medium Devices - Tablets */
        @media (min-width: 769px) and (max-width: 992px) {
          .about-hero-section {
            height: 75vh;
            min-height: 600px;
            padding-top: 80px;
          }
          
          .story-img {
            height: 350px;
          }
          
          .team-member-img {
            height: 280px;
          }
        }
        
        /* Large Devices - Desktops */
        @media (min-width: 993px) and (max-width: 1199px) {
          .about-hero-section {
            height: 80vh;
            min-height: 650px;
            padding-top: 60px;
          }
          
          .story-img {
            height: 400px;
          }
        }
        
        /* Very Large Screens */
        @media (min-width: 1200px) {
          .about-hero-section {
            height: 85vh;
            min-height: 700px;
            padding-top: 40px;
          }
        }
        
        /* Landscape Orientation on Mobile */
        @media (max-height: 600px) and (orientation: landscape) {
          .about-hero-section {
            height: 100vh;
            min-height: 400px;
            padding-top: 80px;
          }
          
          .hero-title {
            font-size: 2rem;
            margin-bottom: 0.5rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
            margin-bottom: 1.5rem;
          }
          
          .team-member-img {
            height: 200px;
          }
        }
        
        /* Accessibility: Focus states */
        button:focus,
        input:focus,
        a:focus {
          outline: 2px solid #B59A5A;
          outline-offset: 2px;
        }
      `}</style>
    </>
  );
};

export default About;